// PartBPage4/index.jsx - Part B Page 4 (Student Editor - View Only Teacher Assessment)
import React from 'react';
import { useActivityContext } from '../index';

const PartBPage4 = () => {
  const { activity } = useActivityContext();
  // CORRECT PATH: activity.part_b.page_4.stage2
  const stage2Data = activity?.part_b?.page_4?.stage2 || {
    awareness: [],
    sensitivity: [],
    creativity: [],
    comments: ''
  };

  const awarenessItems = [
    "The learner shows evidence of sufficient engagement in the process of project work.",
    "The learner is able to present a draft done as per the project schedule.",
    "The learner is able to demonstrate thorough research skills on the project task/topic.",
    "The learner is able to identify possible areas of improvement in the draft.",
    "The learner is aware of different team members' contributions to the project so far.",
    "The product created demonstrates the application of knowledge gain."
  ];

  const sensitivityItems = [
    "The learner participates in group discussions respectfully.",
    "The learner responds appropriately to other group members' emotions during the project.",
    "The learner attempts to build a positive emotional atmosphere within the group.",
    "The learner demonstrates some understanding of the social relevance of the project.",
    "The learner refrains from expressing negative emotions during group work.",
    "The learner participates enthusiastically and diligently in the project."
  ];

  const creativityItems = [
    "The learner demonstrates flexibility with respect to project roles.",
    "The learner displays willingness to consider different sources of information, tools, or materials.",
    "The learner takes initiative to complete the project tasks.",
    "The learner builds on the unique elements introduced earlier, or incorporates them at this stage.",
    "The learner shows evidence of having considered and selected some ideas from the brainstorming stage.",
    "The product created is innovative and useful to the community."
  ];

  const renderCheckboxSection = (title, items, category) => {
    const checkedIndices = stage2Data[category] || [];
    const total = checkedIndices.length;

    return (
      <div style={{ marginBottom: '16px' }}>
        <div style={{
          backgroundColor: '#F4A460',
          color: 'white',
          padding: '8px 12px',
          fontWeight: 'bold',
          fontSize: '14px',
          marginBottom: '8px'
        }}>
          {title}
        </div>
        <div style={{
          backgroundColor: '#FFE5D5',
          padding: '12px'
        }}>
          {items.map((item, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: '6px',
              fontSize: '14px',
              lineHeight: '1.4',
              color: '#666'
            }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #999',
                marginRight: '8px',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '1px',
                fontSize: '12px',
                backgroundColor: '#f9f9f9'
              }}>
                {checkedIndices.includes(index) && '✓'}
              </div>
              <span>{item}</span>
            </div>
          ))}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginTop: '10px',
            fontSize: '14px',
            fontWeight: 'bold'
          }}>
            <span style={{ marginRight: '10px' }}>Total number of (✓):</span>
            <div style={{
              width: '35px',
              height: '35px',
              border: '3px solid #F4824C',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '14px'
            }}>
              {total}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderText = (text) => {
    if (!text || text.trim() === '') return <div style={{ fontSize: '14px', color: '#999', fontStyle: 'italic' }}>Not filled by teacher yet</div>;
    return <div style={{ fontSize: '14px', lineHeight: '1.5', whiteSpace: 'pre-wrap', color: '#666' }}>{text}</div>;
  };

  return (
    <div style={{
        width: '100%',
        maxWidth: '1400px',
        minHeight: '80vh',
        margin: '0 auto',
        padding: '40px',
        backgroundColor: 'white',
        fontFamily: "'Poppins', Arial, sans-serif",
        position: 'relative',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
      }}>
        {/* Decorative Corners */}
        

        {/* Header */}
        <div style={{
          backgroundColor: '#F4824C',
          color: 'white',
          fontSize: '14px',
          fontWeight: 'bold',
          padding: '10px',
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          Stage 2
        </div>

        {/* Info Note */}
        <div style={{
          backgroundColor: '#E3F2FD',
          borderLeft: '4px solid #2196F3',
          padding: '10px 15px',
          marginBottom: '16px',
          fontSize: '12px',
          color: '#1565C0'
        }}>
          📘 This page contains teacher assessment. Your teacher will fill this section after reviewing your work.
        </div>

        {/* Teacher Assessment Label */}
        <div style={{
          backgroundColor: '#F4824C',
          color: 'white',
          padding: '8px 14px',
          fontWeight: 'bold',
          fontSize: '12px',
          display: 'inline-block',
          marginBottom: '12px'
        }}>
          Teacher Assessment
        </div>

        <div style={{
          fontSize: '14px',
          fontWeight: 'bold',
          marginBottom: '12px'
        }}>
          Tick (✓) all statements that apply.
        </div>

        {renderCheckboxSection('Awareness', awarenessItems, 'awareness')}
        {renderCheckboxSection('Sensitivity', sensitivityItems, 'sensitivity')}
        {renderCheckboxSection('Creativity', creativityItems, 'creativity')}

        {/* Comments Section */}
        <div style={{ marginTop: '20px' }}>
          <div style={{
            fontWeight: 'bold',
            fontSize: '14px',
            marginBottom: '8px'
          }}>
            Brief comments and pedagogical interventions recommended:
          </div>
          <div style={{
            backgroundColor: '#FFE5D5',
            padding: '12px',
            minHeight: '80px',
            borderRadius: '4px'
          }}>
            {renderText(stage2Data.comments)}
          </div>
        </div>

        {/* Bottom Corners */}
        
        
      </div>

  );
};

export default PartBPage4;
